import { formatTimeSlotLabel } from 'src/helpers/scheduler-time.helpers';

export const BOOKING_TIMEZONE_OPTIONS = [
  { value: 'America/New_York', label: 'Eastern' },
  { value: 'America/Chicago', label: 'Central' },
  { value: 'America/Denver', label: 'Mountain' },
  { value: 'America/Los_Angeles', label: 'Pacific' },
] as const;

export const DEFAULT_BOOKING_START_TIME = '11:00';
export const DEFAULT_BOOKING_END_TIME = '15:00';
export const DEFAULT_BOOKING_TIMEZONE = 'America/New_York';

export function getBookingTimezoneLabel(timezone: string): string {
  return BOOKING_TIMEZONE_OPTIONS.find((option) => option.value === timezone)?.label ?? timezone;
}

export function formatEffectiveBookingWindow(
  startTime: string,
  endTime: string,
  timezone: string,
): string {
  const zoneLabel = getBookingTimezoneLabel(timezone);
  return `Slots are offered ${formatTimeSlotLabel(startTime)} – ${formatTimeSlotLabel(endTime)} ${zoneLabel}, Monday through Friday`;
}
